export default "__VITE_ASSET__DCaWv0cn__"